import { isNotServerSideRendering } from 'helpers/env';

export const makePaginationUrl = (baseUrl: string, pageNumber: number): string => {
  if (!pageNumber || pageNumber === 1) {
    return baseUrl;
  } else {
    return `${baseUrl}/page-${pageNumber}`;
  }
};

export const getPageCountFromUrl = (): number => {
  if (isNotServerSideRendering()) {
    const matches = /count=([0-9]+)/.exec(window?.location?.search);
    const match = matches ? matches[1] : false;
    if (match) {
      return parseInt(match, 10);
    }
  }

  return 0;
};
